import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { useTranslation } from 'react-i18next';
import OKCancelDialog from '../../atoms/Dialog/OKCancelDialog';
import Typography from '@material-ui/core/Typography';

type StudyButtonProps = {
  studyStatus: number;
  isStudyCheck: boolean;
  isStudyCancelCheck: boolean;
  isStudyCancelRun: boolean;
  studyCount: number;
  onClick: () => void;
  onCancelClick: () => void;
};

const IoTDevListStudyButton: React.FC<StudyButtonProps> = (props) => {
  const { t } = useTranslation();
  const [studyStatus, setStudyStatus] = useState<number>(props.studyStatus);
  const [isStudyCheck, setIsStudyCheck] = useState<boolean>(props.isStudyCheck);
  const [isStudyCancelRun, setIsStudyCancelRun] = useState<boolean>(props.isStudyCancelRun);
  //const [studyFlg, setStudyFlg] = useState<number>(props.studyFlg);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');

  //学習　完了失敗未　以外の場合はキャンセル可能
  const isCancelCheck: boolean = props.isStudyCancelCheck;

  useEffect(() => {
    setStudyStatus(props.studyStatus);
    setIsStudyCheck(props.isStudyCheck);
    setIsStudyCancelRun(props.isStudyCancelRun);
  }, [props.studyStatus, props.isStudyCheck, props.isStudyCancelRun]);

  const getStudyButtonColor = (state?: number): string => {
    if (state == undefined) return 'silver';

    switch (state) {
      case 0: //学習中
        return 'royalblue';
      case 1: //学習完了
        return 'green';
      case 2: //学習前
        return 'royalblue';
      case 3: //次回学習待ち
        return 'royalblue';
      case 4: //学習失敗
        return 'red';
      case 5: //学習未
        return 'gray';
      default:
        return 'silver';
    }
  };

  const getStudyLabelColor = (state?: number): string => {
    if (state == undefined) return 'silver';

    switch (state) {
      case 0: //学習中
        return 'silver';
      case 1: //学習完了
        return 'silver';
      case 2: //学習前
        return 'silver';
      case 3: //次回学習待ち
        return 'silver';
      case 4: //学習失敗
        return 'silver';
      case 5: //学習未
        return 'silver';
      default:
        return 'silver';
    }
  };
  const getStudyButtonText = (state?: number, isStudyCancel?: boolean): string => {
    if (state == undefined) return t('StudyButton.不明', '不明');

    //学習キャンセル中はボタン名をキャンセル中とする
    if (isStudyCancel !== undefined && isStudyCancel === true) return t('StudyButton.キャンセル中', 'ｷｬﾝｾﾙ中');

    switch (state) {
      case 0: //学習中
        return t('StudyButton.学習中', '学習中　');
      case 1: //学習完了
        return t('StudyButton.学習完了', '学習完了');
      case 2: //学習前
        return t('StudyButton.学習前', '待機');
      case 3: //次回学習待ち
        return t('StudyButton.学習中', '学習中　');
      case 4: //学習失敗
        return t('StudyButton.学習失敗', '学習失敗');
      case 5: //学習未
        return t('StudyButton.学習未', '学習未');
      case -1: //使用不可
        return t('StudyButton.使用不可', '使用不可');
      default:
        return t('StudyButton.不明', '不明');
    }
  };

  /**
   *　OK処理
   */
  const handleDialogOkButton = () => {
    if (isCancelCheck) {
      setIsStudyCancelRun(true);
      props.onCancelClick();
    } else {
      props.onClick();
      //即学習中に状態を変える
      setStudyStatus(0);
    }
    setDialogOpen(false);
  };

  /**
   * 確認ダイアログ
   */
  const handleCheckDialogShow = () => {
    {
      isCancelCheck !== true
        ? setShowMessage(t('IoTDevListStudyButton.学習処理を実行します', '学習処理を実行しますか？'))
        : setShowMessage(t('IoTDevListStudyButton.学習処理をキャンセルしますか', '学習処理をキャンセルしますか？'));
    }

    setDialogOpen(true);
  };

  /**
   * ボタンラベル表示
   * @returns
   */
  const label_disv = () => {
    return (
      <Button
        disabled={true}
        variant="outlined"
        style={{
          color: isStudyCheck === true ? getStudyButtonColor(studyStatus) : getStudyLabelColor(studyStatus),
          borderColor: isStudyCheck === true ? getStudyButtonColor(studyStatus) : getStudyLabelColor(studyStatus),
          width: '130px',
        }}
        onClick={() => {
          handleCheckDialogShow();
        }}
      >
        {getStudyButtonText(studyStatus, isStudyCancelRun)}
      </Button>
    );
  };

  //console.debug(['- 画面描画開始 -', props]);
  //学習中の場合ボタン操作を可能に変更
  //次回学習待ちの時だけキャンセルができるため、ボタンを押せる状態にする
  return (
    <div>
      {isStudyCheck === true || isCancelCheck === true ? (
        <Button
          disabled={false}
          variant="outlined"
          style={{
            color: getStudyButtonColor(studyStatus),
            borderColor: getStudyButtonColor(studyStatus),
            width: '130px',
          }}
          onClick={() => {
            handleCheckDialogShow();
          }}
        >
          {getStudyButtonText(studyStatus, isStudyCancelRun)}
        </Button>
      ) : (
        label_disv()
      )}
      <OKCancelDialog
        open={dialogOpen}
        onOK={() => handleDialogOkButton()}
        onCancel={() => setDialogOpen(false)}
        title={t('IoTDevListStudyButton.確認', '確認')}
        okText={t('IoTDevListStudyButton.OK', 'OK')}
        cancelText={t('IoTDevListStudyButton.キャンセル', 'キャンセル')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </OKCancelDialog>
    </div>
  );
};

export default IoTDevListStudyButton;
